<template>
  <modal
    name="auction-summary-modal"
    style="z-index: 1001;"
    transition="fade"
    @closed="$emit('updateComparisonData')"
    @before-open="handleBeforeOpen"
    :adaptive="true"
    :scrollable="true"
    width="60%"
    height="90%"
  >
    <div id="modal-header" class="w-100 px-4 py-2 position-relative bg-danger-gradient">
      <div class="w-100 d-flex">
        <p>
          Աճուրդի ամփոփում
        </p>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('auction-summary-modal')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div id="modal-body">
      <div class="row justify-content-center align-items-center">
        <div class="col-12 mt-5 px-5">
          <div style="font-size: 14px;">
            <div>Աճուրդի արդյունքները`</div>
            <br/>

            <table class="auction-summary-modal">

              <tr class="separate-row">
                <td colspan="13">
                  <br>
                </td>
              </tr>
              <tr class="main-row">
                <td rowspan="3" colspan="2">
                  Չ/Հ
                </td>
                <td rowspan="3" colspan="3">
                  Մասնակիցների անվանումները
                </td>
                <td colspan="8">
                  Յուրաքանչյուր մասնակցի հայտով ներկայացված գինը
                </td>
              </tr>
              <tr class="main-row">
                <td colspan="6">
                  ՀՀ դրամ
                </td>
              </tr>
              <tr class="main-row">
                <td colspan="6" rowspan="2">
                  Գինն առանց ԱԱՀ
                </td>
              </tr>
              <tr class="main-row" ></tr>

              <tbody
                v-for="(cpvRow, cpvIndex) in cpvRows"
                :key="cpvRow.code"
              >
              <!-- Parent row -->
              <tr class="main-row">
                <td colspan="2">
                  Չափաբաժին {{ cpvIndex + 1 }}՝
                </td>
                <td colspan="6">
                  {{ cpvRow.name }} - {{ cpvRow.code }}
                </td>
                <td>
                  {{ cpvRow.initial_price }}
                </td>
                <td colspan="4">
                  Կարգավիճակ
                </td>
              </tr>

              <!-- Child rows -->
              <tr
                class="main-row"
                v-for="(participant, participantIndex) in cpvRow.participants"
                :key="participant.id"
              >
                <td colspan="2">
                  {{ participantIndex + 1 }}
                </td>

                <td colspan="3">
                  {{ participant.user_name }}
                </td>

                <td colspan="4">
                  {{ participant.amount }} / {{ participant.final_price_submitted }}
                </td>

                <td colspan="4">
                  <div v-if="isView" class="form-check">
                    <label v-if="participant.is_satisfactory" class="form-check-label" >
                      Բավարար
                    </label>
                    <div v-else>
                      <label  class="form-check-label" >
                        Անբավարար
                      </label>
                      <div class="form-group text-left my-2">
                        <label>Հիմնավորում</label>
                        <textarea disabled v-model="participant.reason" class="form-control br-8" rows="3"></textarea>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="form-check mb-2">
                      <label>
                        <input
                          v-model="participant.is_satisfactory"
                          :value="true"
                          class="form-check-input"
                          type="radio"
                          :name="`is_satisfactory-${participant.id}`"
                          :id="`is_satisfactory-${participant.id}`"
                        >
                        <label class="form-check-label" :for="`is_satisfactory-${participant.id}`">
                          Բավարար
                        </label>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input
                          v-model="participant.is_satisfactory"
                          :value="false"
                          class="form-check-input"
                          type="radio"
                          :name="`is_satisfactory-${participant.id}`"
                          :id="`is_satisfactory-false-${participant.id}`"
                        >
                        <label class="form-check-label" :for="`is_satisfactory-false-${participant.id}`">
                          Անբավարար
                        </label>
                      </label>
                    </div>
                    <div v-if="!participant.is_satisfactory" class="form-group text-left my-2">
                      <label>Հիմնավորում</label>
                      <textarea v-model="participant.reason" class="form-control br-8" rows="3"></textarea>
                    </div>
                  </div>
                </td>
              </tr>

              <tr class="separate-row">
                <td colspan="13" >
                  <br></td>
              </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div id="modal-footer">
      <button v-if="!isView" @click="save" type="button" class="btn btn-primary">
        Հրապարակել
      </button>
    </div>
  </modal>

</template>

<script>
export default {
    name: 'AuctionSummaryModal',
    components: {},
    mixins: [],
    props: [],
    data() {
        return {
          status: 1,
          cpvRows: [],
          isView: true
        }
    },
    mounted() {},
    computed: {
        currentOrganized() {
            return this.$store.getters['organizeItender/currentOrganized']
        },
        organizedRowsList() {
            return this.$store.getters['organizeItender/organizedRows']
        },
        me() {
            return this.$store.getters['user/me']
        },
    },
    methods: {
      async getParticipants(auctionId = null) {
        if (!auctionId) {
          auctionId = this.currentOrganized.auction.id
        }
        await this.$client2.get(`auction/get-participants`, {params: {organize_auction_id: auctionId}})
          .then(response => {
            this.cpvRows = response.data?.data
          }).catch(e => {
            console.log(e)
          })
      },
      async handleBeforeOpen({ params }) {
        this.isView = params.isView ?? true;
        await this.getParticipants(params?.organize_auction_id)
      },
      async save() {
        this.$confirm(
          `Վստա՞հ եք, որ ցանկանում եք հրապարակել աճուրդի արդյունքները։
          Հրապարակումից հետո արդյունքները հասանելի կլինեն մասնակիցներին, և այս գործողությունը հնարավոր չի լինի հետարկել։`,
          "Հրապարակել աճուրդի տվյալները",
          "",
          {
            title: '',
            confirmButtonText: 'Հրապարակել',
            cancelButtonText: 'Չեղարկել'
          }
        ).then(async (result) => {
          if(result){
            const participants = this.cpvRows.flatMap(cpv =>
              cpv.participants.map(participant => ({
                id: participant.id,
                reason: participant.reason,
                is_satisfactory: Number(participant.is_satisfactory)
              }))
            );

            await this.$client2.post(`auction/publish-auction-summary`, {organize_auction_id: this.currentOrganized.auction.id, rows: participants})
              .then(response => {

                if (response.data?.status) {
                  this.$fire({
                    text: "Աճուրդի արդյունքները հրապարակվել են",
                    type: "info",
                    confirmButtonText: 'Լավ'
                  })

                  this.$store.dispatch('organizeItender/getCurrent', this.$route.params.id)
                  this.$modal.hide('auction-summary-modal')
                }
              }).catch(e => {
                console.log(e)
              })
          }
        })
      }
    }
}
</script>
<style scoped>
.auction-summary-modal {
  width: 100%;
}
.auction-summary-modal .separate-row {
  background: rgb(91, 180, 243);
  border: 1px solid black;
  border-collapse: collapse;
  font-size: 11px;
  text-align: center;
  padding: 10px;
  line-height: 1.6;
}
.auction-summary-modal .main-row td {
  border: 1px solid black;
  border-collapse: collapse;
  font-size: 11px;
  text-align: center;
  padding: 5px;
  line-height: 1.6;
}
</style>
